<!--suppress HtmlUnknownAttribute, HtmlDeprecatedTag -->
<kt-portlet>
  <!-- PORTLET LOADING | Bound to TABLE Datasource -->
  <!-- See prop => '~/core/_crud/models/data-sources/_base.datasource.ts' (loading$) -->
  <kt-portlet-header
    [class]="'kt-portlet__head--lg'"
    [title]="'Αποστολές'"
    [viewLoading$]="dataSource.loading$">
    <ng-container ktPortletTools>
      <span class="sp"
        ><mat-spinner
          *ngIf="isPrinting | async"
          color="primary"
          diameter="25"></mat-spinner
      ></span>
      <a
        (click)="refs()"
        class="btn btn-secondary kt-margin-r-10"
        mat-raised-button
        matTooltip="Ανανέωση Αποστολών">
        <i class="la la-refresh"></i>
        <span class="kt-hidden-mobile">Ανανέωση</span>
      </a>
      <a
        (click)="clearFilters()"
        class="btn btn-secondary kt-margin-r-10"
        mat-raised-button
        matTooltip="Αφαίρεση Φίλτρων">
        <i class="far fa-calendar-minus"></i>
        <span class="kt-hidden-mobile">Καθαρισμός Φίλτρων</span>
      </a>
      <input
        #fileInput
        (change)="onFileSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file"
        type="file" />
      <input
        #fileInputElta2
        (change)="onFileSelectedElta2($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_elta2"
        type="file" />
      <input
        #fileInputTaxyPaid
        (change)="onTaxyPaidSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_taxy"
        type="file" />
      <input
        #fileInputACSPaid
        (change)="onACSPaidSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_acs"
        type="file" />
      <input
        #fileInputACSCheck
        (change)="onACSCheckSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_acs_check"
        type="file" />
      <input
        #fileInputKronosPaid
        (change)="onKronosPaidSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_kronos"
        type="file" />
      <input
        #fileInputKronosApproved
        (change)="onKronosApprovedSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_kronos_app"
        type="file" />
      <input
        #fileInputSPDXPaid
        (change)="onSPDXPaidSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_spdx"
        type="file" />
      <input
        #fileInputSPDXValidate
        (change)="onSPDXValidateSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_spdx_validate"
        type="file" />
      <input
        #fileInputSendDelivered
        (change)="onSendDeliveredSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_send_delivered"
        type="file" />
      <input
        #fileInputReturnDelivered
        (change)="onReturnDeliveredSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_return_delivered"
        type="file" />
      <input
        #fileInputCheckKg
        (change)="onCkeckKgSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_check_kg"
        type="file" />
      <input
        #fileInputCSPaid
        (change)="onCSPaidSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_cs"
        type="file" />
      <input
        #fileInputXLSSearch
        (change)="onXLSSearchSelected($event)"
        acccept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        hidden
        id="file_search"
        type="file" />
      <!-- Buttons (Material Angular) | See off.documentations 'https://material.angular.io/components/button/overview' -->
      <!-- mat-raised-button | Rectangular contained button w/ elevation  -->
      <button
        *ngIf="adminView"
        [matMenuTriggerFor]="menu"
        color="warn"
        mat-raised-button>
        <mat-icon>description</mat-icon>
        XLS
      </button>
      <mat-menu #menu="matMenu" class="xls-menu" xPosition="before">
        <button (click)="fileInput.click()" class="elta-red" mat-menu-item>
          <i class="fas fa-money-check-alt"></i>
          <span>Εισπραγμένες ΕΛΤΑ</span>
        </button>
        <button (click)="fileInputElta2.click()" class="elta-red" mat-menu-item>
          <i class="fas fa-money-check-alt"></i>
          <span>Εισπραγμένες ΕΛΤΑ 2</span>
        </button>
        <mat-divider></mat-divider>
        <button
          (click)="fileInputTaxyPaid.click()"
          class="taxy-orange"
          mat-menu-item>
          <i class="fas fa-money-check-alt"></i>
          <span>Εισπραγμένες ΤΑΧΥΔΕΜΑ/DIAKINISIS</span>
        </button>
        <mat-divider></mat-divider>
        <button
          (click)="fileInputACSPaid.click()"
          class="elta-red"
          mat-menu-item>
          <i class="fas fa-money-check-alt"></i>
          <span>Εισπραγμένες ACS</span>
        </button>
        <button
          (click)="fileInputACSCheck.click()"
          class="elta-red"
          mat-menu-item>
          <i class="fas fa-balance-scale-right"></i>
          <span>Έλεγχος Βάρους ACS</span>
        </button>
        <mat-divider></mat-divider>
        <!--button
          (click)="fileInputKronosApproved.click()"
          class="speedex-green"
          mat-menu-item>
          <i class="fas fa-money-check-alt"></i>
          <span>Εγκεκριμένες KRONOS</span>
        </button-->
        <button
          (click)="fileInputKronosPaid.click()"
          class="speedex-green"
          mat-menu-item>
          <i class="fas fa-money-check-alt"></i>
          <span>Εισπραγμένες KRONOS</span>
        </button>
        <mat-divider></mat-divider>
        <button (click)="fileInputCSPaid.click()" class="cs-blue" mat-menu-item>
          <i class="fas fa-money-check-alt"></i>
          <span>Εισπραγμένες Courier Center</span>
        </button>
        <mat-divider></mat-divider>
        <button
          (click)="fileInputSPDXPaid.click()"
          class="speedex-green"
          mat-menu-item>
          <i class="fas fa-money-check-alt"></i>
          <span>Εισπραγμένες SPEEDEX</span>
        </button>
        <button
          (click)="fileInputSPDXValidate.click()"
          class="speedex-green"
          mat-menu-item>
          <i class="fas fa-tasks"></i>
          <span>Διασταύρωση SPEEDEX</span>
        </button>
        <button
          (click)="fileInputCheckKg.click()"
          class="speedex-green"
          mat-menu-item>
          <i class="fas fa-balance-scale-right"></i>
          <span>Έλεγχος Βάρους SPEEDEX</span>
        </button>
        <mat-divider></mat-divider>
        <button
          (click)="fileInputSendDelivered.click()"
          class="general-blue"
          mat-menu-item>
          <i class="fas fa-dolly"></i>
          <span>Παράδοση Αποστολών</span>
        </button>
        <button
          (click)="fileInputReturnDelivered.click()"
          class="return-yellow"
          mat-menu-item>
          <i class="fas fa-undo-alt"></i>
          <span>Παράδοση Επιστροφών</span>
        </button>
        <mat-divider></mat-divider>
        <button
          (click)="fileInputXLSSearch.click()"
          class="general-blue"
          mat-menu-item>
          <i class="fas fa-search"></i>
          <span>Αναζήτηση</span>
        </button>
      </mat-menu>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <!-- start::Body (attribute: ktPortletBody) -->
  <kt-portlet-body>
    <!-- start::FILTERS & GROUP ACTIONS -->
    <div class="row align-items-center">
      <div class="col-md-12 kt-margin-bottom-10-mobile">
        <kt-alert
          (close)="onAlertClose($event)"
          *ngIf="serverError | async as err"
          [duration]="10000"
          [showCloseButton]="true"
          type="warn">
          {{ err }}
        </kt-alert>
        <kt-alert
          (close)="onWarningClose($event)"
          *ngIf="customWarning | async as warn"
          [duration]="20000"
          [showCloseButton]="true"
          type="accent">
          {{ warn }}
        </kt-alert>
        <kt-alert
          (close)="onInfoClose($event)"
          *ngIf="customInfo | async as info"
          [duration]="120000"
          [showCloseButton]="true"
          type="primary">
          {{ info }}
        </kt-alert>
        <kt-alert
          (close)="onInfoClose2($event)"
          *ngIf="customInfo2 | async as info"
          [duration]="120000"
          [showCloseButton]="true"
          type="primary">
          {{ info }}
        </kt-alert>
        <kt-alert
          (close)="onInfoClose3($event)"
          *ngIf="customInfo3 | async as info"
          [duration]="120000"
          [showCloseButton]="true"
          type="primary">
          {{ info }}
        </kt-alert>
        <kt-alert
          (close)="onInfoClose4($event)"
          *ngIf="customInfo4 | async as info"
          [duration]="120000"
          [showCloseButton]="true"
          type="primary">
          {{ info }}
        </kt-alert>
      </div>
    </div>

    <div class="kt-form">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Αναζήτηση Αποστολών</mat-panel-title>
          <mat-panel-description>
            Αναζήτηση αποστολών και με απλά και σύνθετα φίλτρα.
          </mat-panel-description>
        </mat-expansion-panel-header>
        <!-- start::FILTERS -->
        <div class="kt-form__filtration">
          <div class="row align-items-center">
            <div class="col-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <input #searchInput matInput placeholder="Παραλήπτης" />
                <mat-hint align="start"
                  ><strong>Αναζήτηση</strong> με παραλήπτη</mat-hint
                >
              </mat-form-field>
            </div>
            <div class="col-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <input
                  #searchInputTel
                  matInput
                  placeholder="Τηλέφωνο Παραλήπτη" />
                <mat-hint align="start"
                  ><strong>Αναζήτηση</strong> με τηλέφωνο παραλήπτη</mat-hint
                >
              </mat-form-field>
            </div>
            <div class="col-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <mat-label>Επιλογή Courier</mat-label>
                <mat-select
                  (selectionChange)="courierChange($event)"
                  [(value)]="courier">
                  <mat-option>Οποιοδήποτε</mat-option>
                  <mat-option value="ELTA"> ΕΛΤΑ Courier</mat-option>
                  <mat-option value="ELTA2"> ΕΛΤΑ Courier 2</mat-option>
                  <mat-option value="SPEEDEX"> SPEEDEX</mat-option>
                  <mat-option value="COURIER_CENTER">
                    COURIER CENTER</mat-option
                  >
                  <mat-option value="TAXYDEMA"> ΤΑΧΥΔΕΜΑ</mat-option>
                  <mat-option value="DIAKINISIS"> DIAKINISIS</mat-option>
                  <mat-option value="KRONOS"> KRONOS</mat-option>
                  <mat-option value="ACS1"> ACS1</mat-option>
                  <mat-option value="ACS2"> ACS2</mat-option>
                  <mat-option value="ACS3"> ACS3</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpFAe('change', $event)"
                  [(ngModel)]="dpFA"
                  [matDatepicker]="dpFAP"
                  matInput
                  placeholder="Εγκρίθηκε από" />
                <mat-datepicker-toggle
                  [for]="dpFAP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpFAP></mat-datepicker>
                <mat-hint align="start"
                  ><strong>Από</strong> ημερομηνία έγκρισης</mat-hint
                >
              </mat-form-field>
            </div>
            <div class="col kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpTAe('change', $event)"
                  [(ngModel)]="dpTA"
                  [matDatepicker]="dpTAP"
                  matInput
                  placeholder="Εγκρίθηκε εώς" />
                <mat-datepicker-toggle
                  [for]="dpTAP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpTAP></mat-datepicker>
                <mat-hint align="start"
                  ><strong>Εώς</strong> ημερομηνία έγκρισης</mat-hint
                >
              </mat-form-field>
            </div>
            <div class="col kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpFRe('change', $event)"
                  [(ngModel)]="dpFR"
                  [matDatepicker]="dpFRP"
                  matInput
                  placeholder="Επεστράφη από" />
                <mat-datepicker-toggle
                  [for]="dpFRP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpFRP></mat-datepicker>
                <mat-hint align="start"
                  ><strong>Από</strong> ημερομηνία επιστροφής</mat-hint
                >
              </mat-form-field>
            </div>
            <div class="col kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpTRe('change', $event)"
                  [(ngModel)]="dpTR"
                  [matDatepicker]="dpTRP"
                  matInput
                  placeholder="Επεστράφη εώς" />
                <mat-datepicker-toggle
                  [for]="dpTRP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpTRP></mat-datepicker>
                <mat-hint align="start"
                  ><strong>Εώς</strong> ημερομηνία επιστροφής</mat-hint
                >
              </mat-form-field>
            </div>
          </div>
          <div class="row align-items-center mbr">
            <div *ngIf="adminView" class="col kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpFPe('change', $event)"
                  [(ngModel)]="dpFP"
                  [matDatepicker]="dpFPP"
                  matInput
                  placeholder="Εισπράχθηκε από" />
                <mat-datepicker-toggle
                  [for]="dpFPP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpFPP></mat-datepicker>
                <mat-hint align="start"
                  ><strong>Από</strong> ημερομηνία είσπραξης</mat-hint
                >
              </mat-form-field>
            </div>
            <div *ngIf="adminView" class="col kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpTPe('change', $event)"
                  [(ngModel)]="dpTP"
                  [matDatepicker]="dpTPP"
                  matInput
                  placeholder="Εισπράχτηκε εώς" />
                <mat-datepicker-toggle
                  [for]="dpTPP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpTPP></mat-datepicker>
                <mat-hint align="start"
                  ><strong>Εώς</strong> ημερομηνία έγκρισης</mat-hint
                >
              </mat-form-field>
            </div>
            <div class="col-md-3 kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpFIe('change', $event)"
                  [(ngModel)]="dpFI"
                  [matDatepicker]="dpFIP"
                  matInput
                  placeholder="Εξοφλήθη από" />
                <mat-datepicker-toggle
                  [for]="dpFIP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpFIP></mat-datepicker>
                <mat-hint align="start"
                  ><strong>Από</strong> ημερομηνία εξόφλησης</mat-hint
                >
              </mat-form-field>
            </div>
            <div class="col-md-3 kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpTIe('change', $event)"
                  [(ngModel)]="dpTI"
                  [matDatepicker]="dpTIP"
                  matInput
                  placeholder="Εξοφλήθη εώς" />
                <mat-datepicker-toggle
                  [for]="dpTIP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpTIP></mat-datepicker>
                <mat-hint align="start"
                  ><strong>Εώς</strong> ημερομηνία εξόφλησης</mat-hint
                >
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="adminView" class="row align-items-center mbr">
            <div *ngIf="adminView" class="col kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpFSDe('change', $event)"
                  [(ngModel)]="dpFSD"
                  [matDatepicker]="dpFSDP"
                  matInput
                  placeholder="Παράδοση Αποστ. από" />
                <mat-datepicker-toggle
                  [for]="dpFSDP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpFSDP></mat-datepicker>
                <mat-hint align="start">
                  <strong>Από</strong> ημερομηνία παράδοσης αποστολής
                </mat-hint>
              </mat-form-field>
            </div>
            <div *ngIf="adminView" class="col kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpTSDe('change', $event)"
                  [(ngModel)]="dpTSD"
                  [matDatepicker]="dpTSDP"
                  matInput
                  placeholder="Παράδοση Αποστ. εώς" />
                <mat-datepicker-toggle
                  [for]="dpTSDP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpTSDP></mat-datepicker>
                <mat-hint align="start">
                  <strong>Εώς</strong> ημερομηνία παράδοσης αποστολής
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-3 kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpFRDe('change', $event)"
                  [(ngModel)]="dpFRD"
                  [matDatepicker]="dpFRDP"
                  matInput
                  placeholder="Παράδοση Επιστ. από" />
                <mat-datepicker-toggle
                  [for]="dpFRDP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpFRDP></mat-datepicker>
                <mat-hint align="start">
                  <strong>Από</strong> ημερομηνία παράδοσης επιστροφής
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-3 kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpTRDe('change', $event)"
                  [(ngModel)]="dpTRD"
                  [matDatepicker]="dpTRDP"
                  matInput
                  placeholder="Παράδοση Επιστ. εώς" />
                <mat-datepicker-toggle
                  [for]="dpTRDP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpTRDP></mat-datepicker>
                <mat-hint align="start">
                  <strong>Εώς</strong> ημερομηνία παράδοσης επιστροφής
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="adminView" class="row align-items-center mbr">
            <div class="col-md-3 kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpFADe('change', $event)"
                  [(ngModel)]="dpFAD"
                  [matDatepicker]="dpFADP"
                  matInput
                  placeholder="Παράδοση Courier από" />
                <mat-datepicker-toggle
                  [for]="dpFADP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpFADP></mat-datepicker>
                <mat-hint align="start">
                  <strong>Από</strong> ημερομηνία παράδοσης courier
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-3 kt-margin-bottom-20-mobile">
              <mat-form-field>
                <input
                  (dateChange)="dpTADe('change', $event)"
                  [(ngModel)]="dpTAD"
                  [matDatepicker]="dpTADP"
                  matInput
                  placeholder="Παράδοση Courier εώς" />
                <mat-datepicker-toggle
                  [for]="dpTADP"
                  matSuffix></mat-datepicker-toggle>
                <mat-datepicker #dpTADP></mat-datepicker>
                <mat-hint align="start">
                  <strong>Εώς</strong> ημερομηνία παράδοσης courier
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="row align-items-center mbr">
            <div class="col kt-margin-bottom-20-mobile">
              <mat-button-toggle-group
                aria-label="Κατάσταση"
                multiple
                name="status">
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  [checked]="fStatus.includes('PENDING')"
                  class="spend tbt"
                  value="PENDING">
                  <i class="flaticon2-download mri aicon"></i>
                  Εκκρεμείς
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  [checked]="fStatus.includes('PROCESSED')"
                  class="sappr tbt"
                  value="PROCESSED">
                  <i class="flaticon2-black-back-closed-envelope-shape mri"></i>
                  Εγκεκριμένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  *ngIf="adminView"
                  [checked]="fStatus.includes('PAID')"
                  class="spaid tbt"
                  value="PAID">
                  <i class="fas fa-money-check-alt mri aicon"></i>
                  Εισπραγμένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  [checked]="fStatus.includes('PAID_APPROVED')"
                  class="spaida tbt"
                  value="PAID_APPROVED">
                  <i class="fas fa-hand-holding-usd mri aicon"></i>
                  Προς Απόδοση
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  [checked]="fStatus.includes('INVOICED')"
                  class="sinv tbt"
                  value="INVOICED">
                  <i class="fas fa-file-invoice-dollar mri aicon"></i>
                  Εξοφλημένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  [checked]="fStatus.includes('RETURNED')"
                  class="sreturned tbt"
                  value="RETURNED">
                  <i class="fas fa-undo-alt mri aicon"></i>
                  Επεστραμένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  [checked]="fStatus.includes('CANCELLATION_PENDING')"
                  class="cancellation_pending tbt"
                  value="CANCELLATION_PENDING">
                  <i class="fas fa-exclamation-circle mri aicon"></i>
                  Προς Ακύρωση
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  [checked]="fStatus.includes('CANCELLED')"
                  class="cancelled tbt"
                  value="CANCELLED">
                  <i class="fas fa-times-circle mri aicon"></i>
                  Ακυρωμένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="fStatusChanged($event)"
                  [checked]="fStatus.includes('CLARIFICATION')"
                  class="cancelled tbt"
                  value="CLARIFICATION">
                  <i class="fas fa-question mri aicon"></i>
                  Προς Διασάφηση
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div class="row align-items-center mbr">
            <div class="col kt-margin-bottom-20-mobile">
              <mat-button-toggle-group
                aria-label="Κατάσταση"
                multiple
                name="status">
                <mat-button-toggle
                  (change)="prepStatusChanged($event)"
                  *ngIf="adminView"
                  [checked]="sprepaid"
                  class="prpaid tbt">
                  <i class="fas fas fa-euro-sign mri aicon"></i>
                  Προπληρωμένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="oprepStatusChanged($event)"
                  *ngIf="adminView"
                  [checked]="oprepaid"
                  class="prpaid tbt">
                  <i class="fas fas fa-euro-sign mri aicon"></i>
                  Μόνο Προπληρωμένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="deliveredStatusChanged($event)"
                  [checked]="delivered"
                  class="prpaid tbt">
                  <i class="fas fa-envelope-open-text mri aicon"></i>
                  Παραδομένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="odeliveredStatusChanged($event)"
                  [checked]="odelivered"
                  class="prpaid tbt">
                  <i class="fas fa-envelope-open-text mri aicon"></i>
                  Μόνο Παραδομένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="returnedStatusChanged($event)"
                  [checked]="returned"
                  class="prpaid tbt">
                  <i class="fas fa-undo-alt mri aicon"></i>
                  Επεστραμένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="oreturnedStatusChanged($event)"
                  [checked]="oreturned"
                  class="prpaid tbt">
                  <i class="fas fa-undo-alt mri aicon"></i>
                  Μόνο Επεστραμένες
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="odsrStatusChanged($event)"
                  [checked]="odsr"
                  class="prpaid tbt">
                  <i class="fas fas fa-shipping-fast mri aicon"></i>
                  Μόνο με Pickup Order
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div class="row align-items-center mbr">
            <div class="col kt-margin-bottom-20-mobile">
              <mat-button-toggle-group
                aria-label="Κατάσταση"
                multiple
                name="status">
                <mat-button-toggle
                  (change)="sendDeliveredStatusChanged($event)"
                  *ngIf="adminView"
                  [checked]="snd_del"
                  class="prpaid tbt">
                  <i class="fas fa-dolly mri aicon"></i>
                  Χωρίς Παράδοση Αποστολής
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="ordStatusChanged($event)"
                  *ngIf="adminView"
                  [checked]="ord"
                  class="prpaid tbt">
                  <i class="fas fa-exchange-alt mri aicon"></i>
                  Χωρίς Παράδοση Επιστροφής
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="ospStatusChanged($event)"
                  [checked]="osp"
                  class="prpaid tbt">
                  <i class="fas fa-file-import mri aicon"></i>
                  Σε Εκκρεμότητα Αποστολής
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="nocodStatusChanged($event)"
                  [checked]="nocod"
                  class="prpaid tbt">
                  <i class="fas fa-money-check-alt mri aicon"></i>
                  Χωρίς Αντικαταβολή
                </mat-button-toggle>
                <mat-button-toggle
                  (change)="withDiffInvWeight($event)"
                  *ngIf="adminView"
                  [checked]="diffinvw"
                  class="prpaid tbt">
                  <i class="fas fa-money-check-alt mri aicon"></i>
                  Με Διαφορές στο τιμολ. Βάρος
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div class="row align-items-center mbr">
            <div class="col kt-margin-bottom-20-mobile">
              <mat-button-toggle-group
                aria-label="Κατάσταση"
                multiple
                name="status">
                <mat-button-toggle
                  (change)="oCodStatusChanged($event)"
                  *ngIf="adminView"
                  [checked]="ocod"
                  class="prpaid tbt">
                  <i class="fas fa-money-check-alt mri aicon"></i>
                  Μόνο με Αντικαταβολή
                </mat-button-toggle>
                <mat-button-toggle
                  class="prpaid tbt"
                  (change)="arsrStatusChanged($event)"
                  [checked]="arsr">
                  <i class="fas fas fa-map mri aicon"></i>
                  Χωρίς Περιοχή
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
        </div>
        <div class="kt-form__filtration">
          <div class="row align-items-center">
            <div class="col-12 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <!--input matInput placeholder="Αναζήτηση Κωδ. Αποστολής" #searchInputKA placeholder="Κωδ. Αποστολής"-->
                <mat-chip-list #vgcodeList aria-label="Κωδ. Αποστολής">
                  <mat-chip
                    (removed)="vg_remove(code)"
                    *ngFor="let code of fvg_codes"
                    class="fchip"
                    removable="true"
                    selectable="false">
                    {{ code }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                  <input
                    (matChipInputTokenEnd)="vg_add($event)"
                    [matChipInputFor]="vgcodeList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    matChipInputAddOnBlur="true"
                    placeholder="Κωδ. Αποστολής..." />
                </mat-chip-list>
                <mat-hint align="start"
                  ><strong>Αναζήτηση</strong> με Κωδ. Αποστολής</mat-hint
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div *ngIf="adminView" class="kt-form__filtration">
          <div class="row align-items-center">
            <div class="col-md-12 kt-margin-bottom-10-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <mat-chip-list #chipList aria-label="Επιλογή χρηστών">
                  <mat-chip
                    (removed)="remove(usr)"
                    *ngFor="let usr of fUsers"
                    [removable]="true"
                    [selectable]="false"
                    class="fchip">
                    {{ usr.lastname }} {{ usr.firstname }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                  <input
                    #usrInput
                    (keyup)="filterUsers($event)"
                    [formControl]="usrCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    placeholder="Χρήστης..." />
                </mat-chip-list>
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="selected($event)">
                  <perfect-scrollbar>
                    <mat-option
                      *ngFor="let option of filteredOptions | async"
                      [value]="option">
                      {{ option.id }}/{{ option.kap }} {{ option.lastname }}
                      {{ option.firstname }} [ {{ option.email }} ]
                    </mat-option>
                  </perfect-scrollbar>
                </mat-autocomplete>
                <mat-hint align="start"
                  ><strong>Αναζήτηση</strong> με χρήστες</mat-hint
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div *ngIf="adminView" class="kt-form__filtration">
          <div class="row align-items-center">
            <div class="col-md-12 kt-margin-bottom-10-mobile">
              <mat-form-field class="mat-form-field-fluid">
                <mat-chip-list #_chipList aria-label="Επιλογή χρηστών">
                  <mat-chip
                    (removed)="_ab_remove(usr)"
                    *ngFor="let usr of fabUsers"
                    [removable]="true"
                    [selectable]="false"
                    class="fchip">
                    {{ usr.lastname }} {{ usr.firstname }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                  <input
                    #_usrInput
                    (keyup)="_ab_filterUsers($event)"
                    [formControl]="_usrCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="_chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    placeholder="Εκτός από Χρήστες..." />
                </mat-chip-list>
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="_ab_selected($event)">
                  <perfect-scrollbar>
                    <mat-option
                      *ngFor="let option of _ab_filteredOptions | async"
                      [value]="option">
                      {{ option.id }}/{{ option.kap }} {{ option.lastname }}
                      {{ option.firstname }} [ {{ option.email }} ]
                    </mat-option>
                  </perfect-scrollbar>
                </mat-autocomplete>
                <mat-hint align="start"
                  ><strong>Αναζήτηση εκτός από</strong> χρήστες</mat-hint
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <div
        *ngIf="adminView"
        class="row align-items-center kt-margin-top-20 kt-margin-bottom-20">
        <kt-totals
          [selection]="false"
          [shipments]="shipmentsResult"
          style="width: 100%"></kt-totals>
      </div>
    </div>

    <div *ngIf="adminView" class="mitsos">
      <div
        [ngClass]="{ show: bigBucket.length > 0 }"
        class="row align-items-center collapse kt-margin-top-20 kt-margin-bottom-20">
        <h3 class="subset">Σύνολα Επιλεγμένων</h3>
      </div>
      <div
        [ngClass]="{ show: bigBucket.length > 0 }"
        class="row align-items-center collapse kt-margin-top-20 kt-margin-bottom-20">
        <kt-totals
          [selection]="true"
          [shipments]="bigBucket"
          [t_selection]="selection.selected"
          style="width: 100%"></kt-totals>
      </div>
    </div>
    <div class="kt-form kt-margin-b-30">
      <!-- end::FILTERS -->

      <!-- start::GROUP ACTIONS -->
      <!-- Group actions list: 'Delete selected' | 'Fetch selected' | 'Update status for selected' -->
      <!-- Group actions are shared for all LISTS -->
      <div
        *ngIf="adminView"
        class="row align-items-center kt-form__group-actions kt-margin-top-20 kt-margin-bottom-20">
        <div class="col-xl-12">
          <div class="kt-form__group kt-form__group--inline mma">
            <div class="kt-form__control kt-form__group--inline">
              <button
                (click)="selectAllByStatus('PROCESSED')"
                *ngIf="adminView"
                class="approve-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Επιλογή όλων των Εγκρίθηκαν">
                <mat-icon>thumb_up</mat-icon>
                Επιλογή Εγκρίθηκαν
              </button>
              <button
                (click)="selectAllByStatus('PAID')"
                *ngIf="adminView"
                class="paid-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Επιλογή όλων των Εισπράχτηκαν">
                <i class="fas fa-money-check-alt"></i>
                Επιλογή Εισπράχτηκαν
              </button>
              <button
                (click)="selectAllByStatus('PAID_APPROVED')"
                *ngIf="adminView"
                class="paida-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Επιλογή όλων των Προς Απόδοση">
                <i class="fas fa-hand-holding-usd"></i>
                Επιλογή Προς Απόδοση
              </button>
              <button
                (click)="selectAllByStatus('INVOICED')"
                *ngIf="adminView"
                class="inv-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Επιλογή όλων των Εξοφλήθηκαν">
                <i class="fas fa-file-invoice-dollar"></i>
                Επιλογή Εξοφλήθηκαν
              </button>
              <button
                (click)="selectAllByStatus('RETURNED')"
                *ngIf="adminView"
                class="returned-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Επιλογή όλων των Επεστραμένων">
                <i class="fas fa-undo-alt"></i>
                Επιλογή Επεστράφησαν
              </button>
              <button
                (click)="clearSelection()"
                *ngIf="adminView"
                class="clear-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Καθαρισμός Επιλεγμένων απο όλες τις σελίδες">
                <i class="fas fa-trash"></i>
                Καθαρισμός Επιλεγμένων
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="adminView"
        [ngClass]="{ show: bigBucket.length > 0 }"
        class="row align-items-center collapse kt-form__group-actions kt-margin-top-20 kt-margin-bottom-20">
        <!-- We show 'Group Actions' div if smth are selected -->
        <div class="col-xl-12">
          <div class="kt-form__group kt-form__group--inline _mma">
            <div class="kt-form__label kt-form__label-no-wrap">
              <label class="kt--font-bold kt-font-danger-">
                <span>Επιλεγμένες εγγραφές: </span> {{ bigBucket.length }}
              </label>
              <!-- selectedCountsTitle => function from codeBehind (users-list.component.ts file) -->
              <!-- selectedCountsTitle => just returns title of selected items count -->
              <!-- for example: Selected records count: 4 -->
            </div>
            <div class="kt-form__control kt-form__group--inline _mma">
              <button
                (click)="markProcessed()"
                *ngIf="adminView"
                class="approve-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Αλλαγή κατάστασης σε 'Εγκρίθηκε'">
                <mat-icon>thumb_up</mat-icon>
                Εγκρίθηκαν
              </button>
              <button
                (click)="markPaid()"
                *ngIf="adminView"
                class="paid-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Αλλαγή κατάστασης σε 'Εισπράχτηκε'">
                <i class="fas fa-money-check-alt"></i>
                Εισπράχτηκαν
              </button>
              <button
                (click)="markPaidApproved()"
                *ngIf="adminView"
                class="paida-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Αλλαγή κατάστασης σε 'Προς Απόδοση'">
                <i class="fas fa-hand-holding-usd"></i>
                Προς Απόδοση
              </button>
              <button
                (click)="markInvoiced()"
                *ngIf="adminView"
                class="inv-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Αλλαγή κατάστασης σε 'Εξοφλημένη'">
                <i class="fas fa-file-invoice-dollar"></i>
                Εξοφλημένες
              </button>
              <button
                (click)="massMarkCancellationPending()"
                *ngIf="adminView"
                class="returned-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Αλλαγή κατάστασης σε 'Προς Ακύρωση'">
                <i class="fas fa-exclamation-circle"></i>
                Προς Ακύρωση
              </button>
              <button
                (click)="check_kg()"
                *ngIf="adminView"
                class="approve-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Διασταυρωση βάρους με τα ΕΛΤΑ">
                <i class="fas fa-balance-scale-right"></i>
                Έλεγχος Βάρους
              </button>
              <button
                (click)="massMarkPrepaid()"
                *ngIf="adminView"
                class="prepaid-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Μαρκάρισμα ως Προπληρωμένες">
                <i class="fas fa-euro-sign"></i>
                Προπληρωμένες
              </button>
              <button
                (click)="genXLS()"
                *ngIf="adminView"
                class="xls-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Δημιουργία Excel από τις επιλεγμένες">
                <i class="fas fa-file-excel xls-i"></i>
                Δημιουργία Excel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="adminView && fUsers.length === 1"
        [ngClass]="{ show: bigBucket.length > 0 }"
        class="row align-items-center collapse kt-form__group-actions kt-margin-top-20 kt-margin-bottom-20">
        <!-- We show 'Group Actions' div if smth are selected -->
        <div class="col-xl-12">
          <div class="kt-form__group kt-form__group--inline">
            <div class="kt-form__label kt-form__label-no-wrap">
              <label class="kt--font-bold kt-font-danger-">
                <span>Έκδοση παραστατικών: </span>
              </label>
            </div>
            <div class="kt-form__control kt-form__group--inline _mma">
              <button
                (click)="createCodXLS()"
                class="cod-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Παραγωγή Απόδοσης Αντικαταβολών">
                <i class="fas fa-file-excel"></i>
                Απόδοση Αντικαταβολών
              </button>
              <button
                (click)="createChargesXLS()"
                class="charges-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Παραγωγή Ανάλυσης Χρεώσεων">
                <i class="fas fa-file-excel"></i>
                Ανάλυση Χρεώσεων
              </button>
              <button
                (click)="createReceipt()"
                class="receipt-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Παραγωγή Απόδειξης Πληρωμής">
                <i class="fas fa-file-pdf"></i>
                Απόδειξη Πληρωμής
              </button>
              <button
                (click)="addExtraCharge()"
                class="returned-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Προσθήκη επιπλέον χρέωσης στην εκκαθάριση">
                <i class="fas fa-plus"></i>
                Επιπλέον Χρέωση
              </button>

              <button
                (click)="liquidate()"
                [disabled]="isLiquidationInProgress$ | async"
                class="liquidate-btn-l mat-button-mt-4"
                mat-raised-button
                matTooltip="Εκκαθάριση Αποστολών">
                <i
                  *ngIf="(isLiquidationInProgress$ | async) === false"
                  class="fas fa-euro-sign"
                  style="margin-right: 4px"></i>
                {{
                  (isLiquidationInProgress$ | async)
                    ? 'Επεξεργασία...'
                    : 'Εκκαθάριση'
                }}
              </button>
              <mat-button-toggle
                (change)="stateDl($event)"
                checked="true"
                class="prpaid tbt">
                <i class="fas fa-download mri"></i>
                Αυτόματη Μεταφόρτωση Αρχείων
              </mat-button-toggle>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="adminView && extraCharges.length > 0"
      [ngClass]="{ show: bigBucket.length > 0 }"
      class="row align-items-center kt-margin-top-20 kt-margin-bottom-20">
      <!-- We show 'Group Actions' div if smth are selected -->
      <div class="col-xl-12">
        <div class="row kt-margin-top-20 kt-margin-bottom-20">
          <div class="col-xl-12">
            <h4 class="ec-title">Επιπλέον Χρεώσεις</h4>
            <mat-divider></mat-divider>
          </div>
        </div>
        <div
          *ngFor="let charge of extraCharges"
          class="form-group kt-form__group row kt-margin-top-20 kt-margin-bottom-20">
          <div class="col-md-8 kt-margin-bottom-20-mobile plr">
            <mat-form-field class="mat-form-field-fluid">
              <input
                [(ngModel)]="charge.reason"
                matInput
                name="reason-{{ charge.id }}"
                placeholder="Αιτία Χρέωσης" />
              <mat-hint align="start"
                >Παρακαλώ εισάγετε την
                <strong>αιτία της χρέωσης</strong>
              </mat-hint>
            </mat-form-field>
          </div>
          <div class="col-md-3 kt-margin-bottom-20-mobile plr">
            <mat-form-field class="mat-form-field-fluid">
              <input
                [(ngModel)]="charge.charge"
                [textMask]="{ mask: curr_mask1 }"
                class="right-align"
                matInput
                name="charge-{{ charge.id }}"
                placeholder="Ποσό ( &euro; 00.00 )" />
              <mat-hint align="start"
                >Παρακαλώ εισάγετε το
                <strong>ποσό</strong>
              </mat-hint>
            </mat-form-field>
          </div>
          <div class="col-md-1">
            <button
              (click)="removeExtraCharge(charge.id)"
              class="receipt-btn-l mat-button-mt-4"
              mat-raised-button
              matTooltip="Διαγραφή επιπλέον χρέωσης">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mat-table__bottom">
      <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
      <mat-spinner
        *ngIf="dataSource.loading$ | async"
        [diameter]="20"></mat-spinner>
      <!-- MATERIAL PAGINATOR | Binded to datasources -->
      <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
      <mat-paginator
        [length]="dataSource.paginatorTotal$ | async"
        [pageSizeOptions]="[10, 50, 100, 200, 300]"
        [pageSize]="paginator.pageSize"
        [showFirstLastButtons]="true"></mat-paginator>
    </div>

    <!-- MATERIAL TABLE | Binded to datasources -->
    <!-- See off.documentations 'https://material.angular.io/components/table/overview' -->
    <div [class.adm-view]="adminView" class="mat-table__wrapper">
      <mat-table
        #sort1="matSort"
        #table
        [dataSource]="dataSource"
        [matSortActive]="sort.active"
        [matSortDirection]="sort.direction"
        class="lmat-elevation-z8"
        matSort
        matSortDisableClear>
        <!-- Checkbox Column -->

        <!-- Table with selection -->
        <!-- https://run.stackblitz.com/api/angular/v1?file=app%2Ftable-selection-example.ts -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="mat-column-checkbox">
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="mat-column-checkbox">
            <mat-checkbox
              (change)="$event ? toggleSelection(row) : null"
              (click)="$event.stopPropagation()"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container *ngIf="!adminView" matColumnDef="recipient_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Παραλήπτης</mat-header-cell
          >
          <mat-cell *matCellDef="let shipment">{{
            shipment.recipient_name
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="vg_code">
          <mat-header-cell *matHeaderCellDef>Κωδ. Αποστολής</mat-header-cell>
          <mat-cell *matCellDef="let shipment">
            <span *ngIf="shipment.user | lookupUser | async as usr">
              <ng-container *ngIf="!adminView">
                <ng-container *ngIf="shipment.vg_code">{{
                  shipment.vg_code
                }}</ng-container>
                <ng-container *ngIf="!shipment.vg_code">N/A</ng-container>
              </ng-container>
              <a
                *ngIf="!usr.is_company && adminView"
                [matTooltipClass]="'brk-tooltip'"
                matTooltip="
                                                                                                    ID: {{
                  usr.id
                }}&#13;
                                                                                                    Email: {{
                  usr.email
                }}&#13;
                                                                                                    Τηλ: {{
                  usr.phone
                }}&#13;
                                                                                                    Κιν: {{
                  usr.mobile
                }}&#13;
                                                                                                    ΑΦΜ: {{
                  usr.vat
                }}&#13;
                                                                                                    ΑΔΤ: {{
                  usr.adt
                }}
                                                                                                    ">
                <ng-container *ngIf="shipment.vg_code">{{
                  shipment.vg_code
                }}</ng-container>
                <ng-container *ngIf="!shipment.vg_code">N/A</ng-container>
              </a>
              <a
                *ngIf="usr.is_company && adminView"
                [matTooltipClass]="'brk-tooltip'"
                matTooltip="
                                                                                                   ID: {{
                  usr.id
                }}&#13;
                                                                                                   Email: {{
                  usr.email
                }}&#13;
                                                                                                   Τηλ: {{
                  usr.phone
                }}&#13;
                                                                                                   Κιν: {{
                  usr.mobile
                }}&#13;
                                                                                                   Εταιρία: {{
                  usr.companyName
                }}&#13;
                                                                                                   ΑΦΜ Εταιρίας: {{
                  usr.companyVat
                }}&#13;
                                                                                                   ΔΟΥ: {{
                  usr.companyFiscalService
                }}
                                                                                                   ">
                <ng-container *ngIf="shipment.vg_code">{{
                  shipment.vg_code
                }}</ng-container>
                <ng-container *ngIf="!shipment.vg_code">N/A</ng-container>
              </a>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date_approved">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Εγκρίθηκε</mat-header-cell
          >
          <mat-cell *matCellDef="let shipment">{{
            shipment.date_approved | date
          }}</mat-cell>
        </ng-container>

        <ng-container *ngIf="adminView" matColumnDef="date_paid">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Εισπράχτηκε</mat-header-cell
          >
          <mat-cell *matCellDef="let shipment">{{
            shipment.date_paid | date
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="cod_ammount">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Αν/βολή</mat-header-cell
          >
          <mat-cell *matCellDef="let shipment"
            ><span class="cod">{{
              shipment.cod_ammount | currency: 'EUR'
            }}</span></mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="prereturn_ammount">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Αμ. Αποδ.</mat-header-cell
          >
          <mat-cell *matCellDef="let shipment">
            <span class="prepd">{{
              shipment.prereturn_ammount | currency: 'EUR'
            }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cost">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Χρέωση</mat-header-cell
          >
          <mat-cell *matCellDef="let shipment"
            ><span class="cod">{{ shipment.cost | currency: 'EUR' }}</span>
          </mat-cell>
        </ng-container>

        <ng-container *ngIf="adminView" matColumnDef="prepaid_ammount">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Προπλ.</mat-header-cell
          >
          <mat-cell *matCellDef="let shipment">
            <span class="prepd">{{
              shipment.prepaid_ammount | currency: 'EUR'
            }}</span>
            <span
              *ngIf="shipment.is_prepaid && !shipment.prepaid_ammount"
              class="prepaid"
              ><i class="fas fa-check"></i
            ></span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="is_delivered">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Παρ/μένη</mat-header-cell
          >
          <mat-cell *matCellDef="let shipment">
            <span *ngIf="shipment.is_delivered" class="gready"
              ><i class="fas fa-check"></i
            ></span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="_status">
          <mat-header-cell *matHeaderCellDef>Κατάσταση</mat-header-cell>
          <mat-cell *matCellDef="let shipment">
            <div *ngIf="shipment._status === 'PENDING'" class="pending">
              <span class="status-icon"
                ><i class="flaticon2-download"></i
              ></span>
              <span class="status-text">Εκκρεμεί</span>
            </div>
            <div *ngIf="shipment._status === 'PROCESSED'" class="approved">
              <span class="status-icon"
                ><i class="flaticon2-black-back-closed-envelope-shape"></i
              ></span>
              <span class="status-text">Εγκρίθηκε</span>
            </div>
            <div *ngIf="shipment._status === 'PAID' && adminView" class="paid">
              <span class="status-icon"
                ><i class="fas fa-money-check-alt"></i
              ></span>
              <span class="status-text">Εισπραγμένη</span>
            </div>
            <div
              *ngIf="shipment._status === 'PAID' && !adminView"
              class="approved">
              <span class="status-icon"
                ><i class="flaticon2-black-back-closed-envelope-shape"></i
              ></span>
              <span class="status-text">Εγκρίθηκε</span>
            </div>
            <div *ngIf="shipment._status === 'PAID_APPROVED'" class="paida">
              <span class="status-icon"
                ><i class="fas fa-hand-holding-usd"></i
              ></span>
              <span class="status-text">Προς Απόδ.</span>
            </div>
            <div *ngIf="shipment._status === 'INVOICED'" class="inv">
              <span class="status-icon"
                ><i class="fas fa-file-invoice-dollar"></i
              ></span>
              <span class="status-text">Εξοφλημένη</span>
            </div>
            <div *ngIf="shipment._status === 'RETURNED'" class="returned">
              <span class="status-icon"><i class="fas fa-undo-alt"></i></span>
              <span class="status-text">Επεστραμένη</span>
            </div>
            <div
              *ngIf="shipment._status === 'CANCELLATION_PENDING'"
              class="cancellation_pending">
              <span class="status-icon"
                ><i class="fas fa-exclamation-circle"></i
              ></span>
              <span class="status-text">Προς Ακύρ.</span>
            </div>
            <div *ngIf="shipment._status === 'CANCELLED'" class="cancelled">
              <span class="status-icon"
                ><i class="fas fa-times-circle"></i
              ></span>
              <span class="status-text">Ακυρωμένη</span>
            </div>
            <div *ngIf="shipment._status === 'CLARIFICATION'" class="cancelled">
              <span class="status-icon"><i class="fas fa-question"></i></span>
              <span class="status-text">Διασάφηση</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Ενέργειες</mat-header-cell>
          <mat-cell *matCellDef="let shipment" class="sbn">
            <button
              (click)="viewShipment(shipment)"
              color="primary"
              mat-icon-button
              matTooltip="Λεπτομέρειες Αποστολής">
              <mat-icon>remove_red_eye</mat-icon>
            </button>
            <button
              (click)="viewShipmentTracking(shipment)"
              *ngIf="
                shipment.courier !== 'KRONOS' &&
                shipment._status !== 'PENDING' &&
                shipment._status !== 'CANCELLED' &&
                adminView
              "
              class="paid-btn"
              mat-icon-button
              matTooltip="Εντοπισμός Αποστολής">
              <i class="fas fa-map-marked-alt"></i>
            </button>
            <button
              (click)="viewVoucher(shipment)"
              *ngIf="
                shipment.courier !== 'KRONOS' &&
                shipment._status !== 'PENDING' &&
                shipment._status !== 'CANCELLATION_PENDING' &&
                shipment._status !== 'CANCELLED'
              "
              color="warn"
              mat-icon-button
              matTooltip="Προβολή ΣΥ.ΔΕ.ΤΑ.">
              <mat-icon>picture_as_pdf</mat-icon>
            </button>
            <button
              (click)="markProcessed_s(shipment)"
              *ngIf="
                shipment._status !== 'PENDING' &&
                shipment._status !== 'PROCESSED' &&
                shipment._status !== 'RETURNED' &&
                adminView
              "
              class="approve-btn"
              mat-icon-button
              matTooltip="Αλλαγή κατάστασης σε 'Εγκρίθηκε'"
              type="button">
              <mat-icon>thumb_up</mat-icon>
            </button>
            <button
              (click)="markPaid_s(shipment)"
              *ngIf="
                shipment._status !== 'PENDING' &&
                shipment._status !== 'PAID' &&
                shipment._status !== 'RETURNED' &&
                shipment._status !== 'CANCELLED' &&
                shipment._status !== 'CANCELLATION_PENDING' &&
                adminView
              "
              class="paid-btn"
              mat-icon-button
              matTooltip="Αλλαγή κατάστασης σε 'Εισπράχτηκε'"
              type="button">
              <i class="fas fa-money-check-alt"></i>
            </button>
            <button
              (click)="markPaidApproved_s(shipment)"
              *ngIf="
                shipment._status !== 'PENDING' &&
                shipment._status !== 'PAID_APPROVED' &&
                shipment._status !== 'RETURNED' &&
                shipment._status !== 'PROCESSED' &&
                shipment._status !== 'CANCELLATION_PENDING' &&
                shipment._status !== 'CANCELLED' &&
                adminView
              "
              class="paida-btn"
              mat-icon-button
              matTooltip="Αλλαγή κατάστασης σε 'Προς Απόδοση'"
              type="button">
              <i class="fas fa-hand-holding-usd"></i>
            </button>
            <button
              (click)="markInvoiced_s(shipment)"
              *ngIf="
                shipment._status !== 'PENDING' &&
                shipment._status !== 'INVOICED' &&
                shipment._status !== 'PAID' &&
                shipment._status !== 'PROCESSED' &&
                shipment._status !== 'CANCELLED' &&
                shipment._status !== 'CANCELLATION_PENDING' &&
                adminView
              "
              class="inv-btn"
              mat-icon-button
              matTooltip="Αλλαγή κατάστασης σε 'Εξοφλημένη'"
              type="button">
              <i class="fas fa-file-invoice-dollar"></i>
            </button>
            <button
              (click)="check_kg_s(shipment)"
              *ngIf="
                shipment.courier !== 'KRONOS' &&
                (shipment._status === 'PROCESSED' ||
                  shipment._status === 'PAID' ||
                  shipment._status === 'RETURNED') &&
                adminView &&
                shipment.courier !== 'SPEEDEX'
              "
              class="approve-btn"
              mat-icon-button
              matTooltip="Διασταύρωση βάρους"
              type="button">
              <i class="fas fa-balance-scale-right"></i>
            </button>
            <button
              (click)="markPrepaid(shipment)"
              *ngIf="
                shipment._status == 'PROCESSED' &&
                !shipment.is_prepaid &&
                adminView
              "
              class="prepaid-btn"
              mat-icon-button
              matTooltip="Μαρκάρισμα ως Προπληρωμένη"
              type="button">
              <i class="fas fa-euro-sign"></i>
            </button>
            <button
              (click)="unmarkPrepaid(shipment)"
              *ngIf="
                shipment._status == 'PROCESSED' &&
                shipment.is_prepaid &&
                adminView
              "
              class="unprepaid-btn"
              mat-icon-button
              matTooltip="Μαρκάρισμα ως μη Προπληρωμένη"
              type="button">
              <i class="fas fa-euro-sign"></i>
            </button>
            <button
              (click)="markReturned(shipment)"
              *ngIf="
                shipment._status == 'PROCESSED' && adminView && !shipment.is_dsr
              "
              class="approve-btn"
              mat-icon-button
              matTooltip="Αλλαγή Κατάστασης σε Επεστραμένη"
              type="button">
              <i class="fas fa-arrow-alt-circle-left"></i>
            </button>
            <button
              (click)="markPrereturn(shipment)"
              *ngIf="
                shipment._status == 'PROCESSED' &&
                !shipment.is_prereturn &&
                adminView
              "
              class="prepaid-btn"
              mat-icon-button
              matTooltip="Μαρκάρισμα ως Προ-Αποδομένη"
              type="button">
              <i class="fas fa-file-invoice-dollar"></i>
            </button>
            <button
              (click)="unmarkPrereturn(shipment)"
              *ngIf="
                shipment._status == 'PROCESSED' &&
                shipment.is_prereturn &&
                adminView
              "
              class="unprepaid-btn"
              mat-icon-button
              matTooltip="Μαρκάρισμα ως μη Προ-Αποδομένη"
              type="button">
              <i class="fas fa-file-invoice-dollar"></i>
            </button>
            <button
              (click)="markCancellationPending(shipment)"
              *ngIf="
                shipment._status == 'PROCESSED' &&
                adminView &&
                (shipment.courier == 'ELTA' || shipment.courier == 'ELTA2')
              "
              class="cancellation_pending-btn"
              mat-icon-button
              matTooltip="Υποβολή της αποστολής για έλεγχο ακύρωσης"
              type="button">
              <i class="fas fa-exclamation-circle"></i>
            </button>
            <button
              (click)="checkReturned(shipment)"
              *ngIf="
                shipment.courier !== 'KRONOS' &&
                shipment._status == 'PROCESSED' &&
                adminView &&
                !shipment.is_dsr
              "
              class="approve-btn"
              mat-icon-button
              matTooltip="Έλεγχος Επιστροφής"
              type="button">
              <i class="fas fa-reply"></i>
            </button>
            <button
              (click)="markClarification(shipment)"
              *ngIf="
                (shipment._status == 'PROCESSED' ||
                  shipment._status == 'PAID_APPROVED') &&
                adminView
              "
              class="unprepaid-btn"
              mat-icon-button
              matTooltip="Προς διασάφηση"
              type="button">
              <i class="fas fa-question"></i>
            </button>
            <button
              (click)="toggleSendDelivered(shipment)"
              *ngIf="
                shipment._status == 'PROCESSED' && adminView && !shipment.is_dsr
              "
              [ngClass]="{
                'unprepaid-btn': !shipment.send_delivered,
                'approve-btn': shipment.send_delivered,
              }"
              mat-icon-button
              matTooltip="Αλλαγή παράδοσης αποστολής"
              type="button">
              <i class="fas fa-dolly"></i>
            </button>
            <button
              (click)="toggleReturnDelivered(shipment)"
              *ngIf="(shipment.is_returned || shipment.is_dsr) && adminView"
              [ngClass]="{
                'unprepaid-btn': !shipment.return_delivered,
                'approve-btn': shipment.return_delivered,
              }"
              mat-icon-button
              matTooltip="Αλλαγή παράδοσης επιστροφής"
              type="button">
              <i class="fas fa-exchange-alt"></i>
            </button>
            <button
              (click)="shipmentCancel(shipment)"
              *ngIf="
                shipment._status == 'PROCESSED' &&
                (shipment.courier == 'SPEEDEX' ||
                  shipment.courier == 'COURIER_CENTER' ||
                  shipment.courier == 'TAXYDEMA' ||
                  shipment.courier == 'ACS1' ||
                  shipment.courier == 'ACS2' ||
                  shipment.courier == 'ACS3' ||
                  shipment.courier == 'DIAKINISIS') &&
                shipment.send_pending &&
                !shipment.send_delivered
              "
              class="unprepaid-btn"
              mat-icon-button
              matTooltip="Ακύρωση Αποστολής"
              type="button">
              <i class="fas fa-power-off"></i>
            </button>
            <button
              (click)="viewShipmentTracking(shipment.return_of)"
              *ngIf="shipment.is_dsr && shipment.return_of"
              class="orig-dsr"
              mat-icon-button
              matTooltip="Αρχική Αποστολή">
              <i class="fas fa-mail-bulk"></i>
            </button>
            <button
              (click)="viewShipmentTracking(shipment.return_shipment)"
              *ngIf="shipment.return_shipment"
              class="return-dsr"
              mat-icon-button
              matTooltip="Επιστροφική Αποστολή">
              <i class="fas fa-mail-bulk"></i>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{ is_dsr: row.is_dsr }"></mat-row>
      </mat-table>
      <div *ngIf="!dataSource.hasItems" class="mat-table__message">
        No records found
      </div>
      <!-- Message for empty data  -->
      <div
        *ngIf="dataSource.isPreloadTextViewed$ | async"
        class="mat-table__message">
        Please wait....
      </div>
    </div>

    <div id="pdf_js">
      <ng2-pdfjs-viewer
        #pdfViewerOnDemand
        [download]="false"
        [openFile]="false"
        [startPrint]="true"></ng2-pdfjs-viewer>
    </div>
  </kt-portlet-body>
  <!-- end::Body -->
</kt-portlet>
